import { Button, Typography } from "antd";
import NotificationsPanel from "../Notifications/NotificationsPanel";
const { Text } = Typography;
import { FEATURE_FLAGS } from "../../utils/feature-flag-constants";
import FeatureFlagWrapper from "./FeatureFlagWrapper";

interface TrialData {
  active?: boolean;
  phase?: string | number;
  description?: string;
  [key: string]: unknown;
}

interface HomeHeaderProps {
  trialLabel: string;
  trialData: TrialData;
}

export default function HomeHeader({ trialLabel, trialData }: HomeHeaderProps) {
  if (!Object.keys(trialData).length) return null;

  // Only show the "(Phase X)" suffix when a real phase is known. A blank phase
  // (null/undefined/"" — and the "0" that a blank value surfaces as) must not
  // render as a misleading "Phase 0"; drop the suffix entirely instead.
  const phaseText =
    trialData.phase != null ? String(trialData.phase).trim() : "";
  const hasPhase = phaseText !== "" && phaseText !== "0";

  return (
    <div className="flex justify-between m-4 ">
      <div className="flex">
        <Button
          data-testid="trial-status-pill"
          type="primary"
          className={`w-[94px] ${
            trialData && trialData.active
              ? "bg-[#CAE6D6]  text-[#004A42]"
              : "bg-[#0C98D0]  text-white"
          } font-bold leading-6 text-[14px] text-center border-none shadow-none pointer-events-none`}
        >
          {trialData.active ? "Active" : "Complete"}
        </Button>
        <div className="ml-5 ">
          <p className="mb-1 text-[16px]">
            <strong>{trialLabel}</strong>
            {hasPhase ? ` (Phase ${phaseText})` : ""}
          </p>
          <Text
            style={{ maxWidth: 500 }}
            ellipsis={{ tooltip: trialData.description }}
            className="text-[#556C75] text-[13px]"
          >
            {trialData.description}
          </Text>
        </div>
      </div>

      <div className="flex items-center gap-3">
        <FeatureFlagWrapper
          componentFlag={FEATURE_FLAGS.COMPONENT_NOTIFICATIONS}
        >
          <NotificationsPanel />
        </FeatureFlagWrapper>
      </div>
    </div>
  );
}
